import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { Table } from "@similarweb/pro-logic-components";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";
import { V2_ROUTES } from "app/pages/industry-analysis/routes/routes";
import { useTranslation } from "pro-features/components/WithTranslation";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getColumnConfig } from "./getColumnConfig";
import { useTopCountriesComparisonData } from "./useTopCountriesComparisonData";

export const TopCountriesComparisonWidget = () => {
    const t = useTranslation();
    const { params } = useCurrentStateAndParams();
    const subtitleFilters = useSubtitleFilters("date");
    const { categories } = useCategoriesComparison();
    const { data, isLoading, isError } = useTopCountriesComparisonData(categories);

    const columnConfig = useMemo(() => getColumnConfig(categories), [categories]);

    const handleFooterButtonClick = () => {
        void proNavigator.go(V2_ROUTES.geography, { ...params });
    };

    return (
        <WidgetContainer
            withBorder
            minHeight={385}
            noData={isError}
            title={t("market.research.market.analysis.top.countries.header.title")}
            subtitleFilters={subtitleFilters}
            automationId="industry-analysis-overview-comparison-top-countries"
        >
            <Table
                theme="white"
                sticky={false}
                data={data}
                columnConfig={columnConfig}
                loaderRowCount={5}
                isLoading={isLoading}
                bordersConfig={{ body: true, header: true }}
            />
            {!isLoading ? (
                <Flex
                    justifyContent="flex-end"
                    padding="8px 16px"
                >
                    <Button
                        type="flat"
                        onClick={handleFooterButtonClick}
                    >
                        {t("wwo.geography.button")}
                    </Button>
                </Flex>
            ) : null}
        </WidgetContainer>
    );
};
